import { render } from "./TopPagesListStat.vue?vue&type=template&id=61eb58ca&scoped=true"
import script from "./TopPagesListStat.vue?vue&type=script&lang=js"
export * from "./TopPagesListStat.vue?vue&type=script&lang=js"

import "./TopPagesListStat.vue?vue&type=style&index=0&id=61eb58ca&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61eb58ca"]])

export default __exports__